import React, { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

import { IAuditTrail } from '../../../interfaces';
import { formatDateString } from '../../../shared/utility';
import { ETranslation } from '../../../translations/translation-keys';
import Table from '../../UI/Table/Table';
import TableTh from '../../UI/Table/TableTh/TableTh';
import { useTableSort } from '../../UI/Table/useTableSort';
import classes from './AuditTrailTable.module.scss';

interface IProps {
  auditTrails: Array<IAuditTrail>;
  statusProp?: string;
  sortable?: boolean;
  containerClassName?: string;
  containerStyle?: CSSProperties;
}

const AuditTrailTable: React.FC<IProps> = ({ auditTrails, statusProp, sortable, containerClassName, containerStyle }) => {
  const { t } = useTranslation();
  const { sort, onSort, items: sortedAuditTrails } = useTableSort({ data: auditTrails });

  return (
    <div className={containerClassName} style={containerStyle}>
      <Table hover sortContext={{ sort, onSort }}>
        <thead>
          <tr className={classes.TableHeader}>
            {statusProp}
            {sortable ? (
              <>
                <TableTh sort="created" type="date">{t(ETranslation.COMMON_CREATED)}</TableTh>
                <TableTh sort="user.organization.parent.name">{t(ETranslation.COMMON_OPERATOR_NAME)}</TableTh>
                <TableTh sort="user.organization.name">{t(ETranslation.COMMON_SERVICE_PROVIDER_NAME)}</TableTh>
                <TableTh sort="user.name">{t(ETranslation.OFFER_REQUEST_ACCESS_USERNAME)}</TableTh>
                <TableTh sort="offerRequest.name">{t(ETranslation.CUSTOMER_OFFER_REQUEST)}</TableTh>
                <TableTh sort="parentName">{t(ETranslation.COMMON_SERVICE)}</TableTh>
                <TableTh sort="event">{t(ETranslation.AUDIT_TRAIL_EVENT)}</TableTh>
                <TableTh sort="userAgent">{t(ETranslation.AUDIT_TRAIL_USER_AGENT)}</TableTh>
              </>
            ) : (
              <>
                <th>{t(ETranslation.COMMON_CREATED)}</th>
                <th>{t(ETranslation.COMMON_OPERATOR_NAME)}</th>
                <th>{t(ETranslation.COMMON_SERVICE_PROVIDER_NAME)}</th>
                <th>{t(ETranslation.OFFER_REQUEST_ACCESS_USERNAME)}</th>
                <th>{t(ETranslation.CUSTOMER_OFFER_REQUEST)}</th>
                <th>{t(ETranslation.COMMON_SERVICE)}</th>
                <th>{t(ETranslation.AUDIT_TRAIL_EVENT)}</th>
                <th>{t(ETranslation.AUDIT_TRAIL_USER_AGENT)}</th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {sortedAuditTrails.map(auditTrail => {
            const actionText = auditTrail.actionLabel || auditTrail.event || auditTrail.action || '-';
            const targetText = auditTrail.targetName || auditTrail.offerRequest?.name || '-';
            const clientText = auditTrail.browser ? `${auditTrail.browser}${auditTrail.operatingSystem ? ` (${auditTrail.operatingSystem})` : ''}` : (auditTrail.userAgent || '-');
            return (
              <tr key={auditTrail.id}>
                <td>{auditTrail.created && formatDateString(auditTrail.created)}</td>
                <td>{auditTrail.user?.organization?.parent?.name}</td>
                <td>{auditTrail.user?.organization?.name}</td>
                <td>{auditTrail.user?.name}</td>
                <td>{targetText}</td>
                <td>{auditTrail.parentName || '-'}</td>
                <td>{actionText}</td>
                <td title={auditTrail.userAgent}>{clientText}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default AuditTrailTable;